import Img from 'gatsby-image'
import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import Page from '../components/page'
import theme from '../utils/theme'

import mediaOneMag from '../images/media/home-design-magazine-jul-2011.jpg'
import mediaTwoMag from '../images/media/home-design-magazine-sep-2012.jpg'

const Media = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid ${theme.colors.lightTeal};
  padding-top: 1rem;
  margin-bottom: 1rem;
`

const MediaMagContainer = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  @media (min-width: 32rem) {
    width: 20%;
    padding-right: 1.5rem;
  }

  > img {
    margin: auto;
    border: 1px solid ${theme.colors.muted};
    max-width: 150px;

    @media (min-width: 32rem) {
      max-width: 100%;
    }
  }
`

const MediaDescriptionContainer = styled.div`
  width: 100%;

  @media (min-width: 32rem) {
    width: 80%;
  }

  > h2 {
    text-align: center;

    @media (min-width: 32rem) {
      text-align: left;
    }
  }
`

const MediaPhotosContainer = styled.div`
  width: 100%;
`

const Blockquote = styled.blockquote`
  position: relative;
  color: ${theme.colors.darkTeal};
  font-size: 1.125rem;
  font-style: italic;
  padding-right: 2.5rem;
  padding-left: 2.5rem;

  &:before {
    content: "“";
    position: absolute;
    top: -0.5rem;
    left: 0;
    font-size: 5rem;
    font-style: normal;
    line-height: 1;
    color: ${theme.colors.lightTeal};
  }

  &:after {
    content: "”";
    position: absolute;
    bottom: -3rem;
    right: 0;
    font-size: 5rem;
    font-style: normal;
    line-height: 1;
    color: ${theme.colors.lightTeal};
  }
`

const MediaPage = ({data}) => (
  <Page>
    <Helmet>
      <title>{data.site.siteMetadata.title} in the News</title>
    </Helmet>
    <h1>
      Featured in the Media
    </h1>
    <Media>
      <MediaMagContainer>
        <img
          src={mediaOneMag} 
          alt={data.site.siteMetadata.title}
        />
      </MediaMagContainer>
      <MediaDescriptionContainer>
        <h2>
          <a href="https://www.homeanddesign.com/2011/06/15/a-timeless-retreat">
            A Timeless Retreat
          </a>
        </h2>
        <Blockquote>
          The generous flagstone expanse shaded by white blooming Natchez crape myrtles has timeless style. But the refined country look speaks of a new era... They have transformed a classic two-story family residence into a sparkling retreat...
        </Blockquote>
      </MediaDescriptionContainer>
      <MediaPhotosContainer>
        <Img
          sizes={data.mediaOnePhoto.childImageSharp.sizes} 
          alt={data.site.siteMetadata.title}
        />
      </MediaPhotosContainer>
    </Media>
    <Media>
      <MediaMagContainer>
      <img
          src={mediaTwoMag} 
          alt={data.site.siteMetadata.title}
        />
      </MediaMagContainer>
      <MediaDescriptionContainer>
        <h2>
          <a href="https://www.homeanddesign.com/2012/08/13/chevy-chase-classic-3">
            Chevy Chase Classic
          </a>
        </h2>
        <Blockquote>
          He transformed the former eyesore into a charming presence with eyebrow windows on a new roof. Hawkins supplied the perfect apple tree topiary to enliven a blank garage wall. Today, when viewed from the house, the structure resembles a storybook cottage.
        </Blockquote>
      </MediaDescriptionContainer>
      <MediaPhotosContainer>
        <Img
          sizes={data.mediaTwoPhoto.childImageSharp.sizes} 
          alt={data.site.siteMetadata.title}
        />
      </MediaPhotosContainer>
    </Media>
  </Page>
)

export default MediaPage

export const query = graphql`
  query MediaQuery {
    mediaOnePhoto: file(name: {eq: "hawkins-media-1"}) {
      childImageSharp {
        sizes(maxWidth: 768) {
          ...GatsbyImageSharpSizes
        }
      }
    }
    mediaTwoPhoto: file(name: {eq: "hawkins-media-2"}) {
      childImageSharp {
        sizes(maxWidth: 768) {
          ...GatsbyImageSharpSizes
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/media.js